<div class="image-container">
  <img class="img-fluid img-thumbnail image"
    [src]="imageData && type === 'image' ? imageData : (stampData && type === 'stamp' ? stampData : (customImage && type === 'customRedirection' ? customImage : imageDefault))"
    [alt]="imageData ? 'Imagen' : (stampData ? 'Sello' : (customImage ? 'Imagen botón personalizable' : 'Placeholder'))"
    *ngIf="imageData || stampData || customImage" />
  <img
    *ngIf="((!imageData && type === 'image') || (!stampData && type === 'stamp') || (!customImage && type === 'customRedirection'))"
    class="img-fluid img-thumbnail image" [src]="imageDefault" alt="Placeholder" />
  <!-- <div *ngIf="!imageData && !stampData" class="placeholder">
    <span>Sin imagen</span>
  </div> -->
</div>